import { render, staticRenderFns } from "./PublicVotingVerification.vue?vue&type=template&id=52db6d26&scoped=true"
import script from "./PublicVotingVerification.vue?vue&type=script&lang=js"
export * from "./PublicVotingVerification.vue?vue&type=script&lang=js"
import style0 from "./PublicVotingVerification.vue?vue&type=style&index=0&id=52db6d26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52db6d26",
  null
  
)

export default component.exports